export default {
    props: {
        viewData: {
            type: Object,
            default: () => ({})
        },
    },
    computed: {
        parsedDaysOfWeek() {
            if (!this.viewData.daysOfWeek) return [];
            return this.viewData.daysOfWeek.split(',').map(d => parseInt(d.trim())).filter(d => !isNaN(d));
        },
        parsedTimeRanges() {
            if (!this.viewData.timeRanges) return [];
            return this.viewData.timeRanges.split(',').map(h => parseInt(h.trim())).filter(h => !isNaN(h));
        },
        parsedRegions() {
            if (!this.viewData.regionCodes) return [];
            return this.viewData.regionCodes.split(',').map(r => r.trim()).filter(r => r);
        },
        parsedBillTypes() {
            if (!this.viewData.billTypes) return [];
            return this.viewData.billTypes.split(',').map(b => b.trim()).filter(b => b);
        },
        parsedUserGroups() {
            if (!this.viewData.userClassifyIds) return [];
            return this.viewData.userClassifyIds.split(',').map(u => u.trim()).filter(u => u);
        },
        parsedPackages() {
            if (!this.viewData.packageIds) return [];
            return this.viewData.packageIds.split(',').map(p => parseInt(p.trim())).filter(p => !isNaN(p));
        },
        parsedUsersIncludes() {
            if (!this.viewData.userIds) return [];
            return this.viewData.userIds.split(',').map(u => u.trim()).filter(u => u);
        },
        parsedUsersExcludes() {
            if (!this.viewData.excludeUserIds) return [];
            return this.viewData.excludeUserIds.split(',').map(u => u.trim()).filter(u => u);
        }
    },
    data() {
        return {}
    },
    methods: {
        closeDetail() {
            this.$emit('close')
        },
        formatDateTime(dateTime) {
            if (!dateTime) return 'N/A';
            return new Date(dateTime).toLocaleString();
        },
        getDayName(dayNumber) {
            const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            return days[dayNumber] || dayNumber;
        },
        getBillTypeName(billType) {
            const types = {
                'fixrental': 'Fixed Rental',
                'payusago': 'Pay As You Go'
            };
            return types[billType] || billType;
        }
    }
}